import $ from 'jquery'
export default {
    name: 'registre-crp',
    components: {},
    props: [],
    data () {
        return {
            analyse: "CRP",
           listeRegistre: [],
           loading:false
        }
    },
    computed: {
        registre(){
            return this.$store.getters["registre"]
        }
    },
    mounted () {
        setTimeout(() => {
        $('.shw').fadeIn()
        }, 500);

        this.$store.dispatch("getRegistre",this.analyse).then(
            ()=>{
                this.listeRegistre = this.registre
            }
        )
    },
    methods: {
        saveResults: function(){
            this.loading = true
            this.$store.dispatch("saveDemandesResult",{data:this.listeRegistre,analyse:this.analyse}).then(
                () =>{
                  this.loading = false 
                  this.successMessage()
                }
            )
         },
         successMessage: function(){
             this.$toasted.show('Les résultats ont été enregistrés',{
                 duration: 2000,
                 action:[
                     {
                     text:'X',
                     onClick:(e,toastObject)=>{
                         toastObject.goAway(0);
                     }
                     }
                 ],
                 theme:'toasted-primary',
                 type:'success',
                 position:'top-center'
             })
         },

    }
}


